import React, { useState } from 'react';
import MUIDataTable from 'mui-datatables';

import LoadingPageText from '../../common/Loading/LoadingPageText';
import { tableSettings } from './npatTableSettings';
import { eventHandlers } from './npatHandler';
import { useFetchNonPatientActivityTypes } from '../../../actions/areas/admin/fetchHooks';
import NonPatientActivityTypeCreate from './NonPatientActivityTypeCreate';
import NonPatientActivityTypeEdit from './NonPatientActivityTypeEdit';

export default function NPActivityTypesPage() {
  document.title = 'Non-Patient Activity Types';

  const [state, setState] = useState({
    forceReload: false,
    showCreatePanel: false,
    showEditPanel: false,
    selectedActivity: null,
  });
  const { data, isDataLoading, auth, isTableDataLoading } = useFetchNonPatientActivityTypes(state.forceReload);
  const npatEvents = eventHandlers(state, setState, auth);

  if (isDataLoading)
    return (
      <LoadingPageText showHeader={false}>
        Wait a moment while we gather NonPatient Activity Types info...
      </LoadingPageText>
    );

  const settings = tableSettings({ eventHandlers: npatEvents, isTableDataLoading });

  return (
    <div className="page-content-wrapper">
      <MUIDataTable title={settings.name} data={data} columns={settings.columns} options={settings.options} />
      {state.showCreatePanel && <NonPatientActivityTypeCreate eventHandlers={npatEvents} />}
      {state.showEditPanel && <NonPatientActivityTypeEdit eventHandlers={npatEvents} model={state.selectedActivity} />}
    </div>
  );
}
